export const Alliance = {
    MEGALOS: 'megalos',
};
export const PLAN_TAX = 1.1;
export const BASIC_CAMPAIGN_STRIPE_PLAN_ID = 'annual_campaign_2024_05_15';
export const FIRST_YEAR_CAMPAIGN_STRIPE_PLAN_ID = 'annual_campaign_only_first_year';
export const FIRST_YEAR_CAMPAIGN_AMAZON_PAY_PLAN_ID = 'annual_campaign_only_first_year_amazon_pay';
export const FIRST_YEAR_FRIEND_INVITATION_STRIPE_PLAN_ID = 'annual_friend_invitation_only_first_year';
export const FIRST_YEAR_FRIEND_INVITATION_AMAZON_PAY_PLAN_ID = 'annual_friend_invitation_only_first_year_amazon_pay';
const CAMPAIGN_PRICE_TAX_INCLUDE = 12936;
export class Plan {
    constructor(planData, config) {
        Object.defineProperty(this, "id", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "stripePlanId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "amount", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "planType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "freeTrialDays", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isActive", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "startAt", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "nextPlanId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "corporationId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "alliance", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "thumbnailSrc", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "periodEndFromNow", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "paymentChannel", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "nextPlan", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.id = planData.id;
        this.stripePlanId = planData.stripePlanId;
        this.name = planData.name;
        this.amount = planData.amount;
        this.planType = planData.planType;
        this.freeTrialDays = planData.freeTrialDays;
        this.isActive = planData.isActive;
        this.startAt = planData.startAt;
        this.nextPlanId = planData.nextPlanId;
        this.corporationId = planData.corporationId;
        this.alliance = planData.alliance;
        this.thumbnailSrc = planData.thumbnailSrc ? config.cdnBaseURL + planData.thumbnailSrc : null;
        this.periodEndFromNow = planData.periodEndFromNow;
        this.paymentChannel = planData.paymentChannel;
        if (planData.nextPlan) {
            this.nextPlan = new Plan(planData.nextPlan, config);
        }
    }
    get isPlanAfter2024May15PriceChange() {
        // stripe_plan_idの末尾にプラン作成日を入れてるので、日付で最新のプランか判定しています
        return this.stripePlanId.includes('2024_05_15');
    }
    // 12ヶ月プランかどうか判定
    isAnnualPlan() {
        return this.planType === 'annual';
    }
    // 6ヶ月プランかどうか判定
    isSixMonthPlan() {
        return this.planType === 'six_month';
    }
    // 3ヶ月プランかどうか判定
    isThreeMonthPlan() {
        return this.planType === 'three_month';
    }
    // 月額プランかどうか判定
    isStandardPlan() {
        return this.planType === 'standard';
    }
    // 100円キャンペーンプランかどうか判定
    is100YenCampaignPlan() {
        return this.stripePlanId === '100-yen-campaign';
    }
    // Deprecated: nextPlanIdに値があるのは旧プラン(annual-campaign)時代の実装なのでもう使えない
    isCampaignPlan() {
        return !!this.nextPlanId || this.stripePlanId.includes('campaign');
    }
    get isFirstYearCampaignPlan() {
        return (this.stripePlanId === FIRST_YEAR_CAMPAIGN_STRIPE_PLAN_ID ||
            this.stripePlanId === FIRST_YEAR_CAMPAIGN_AMAZON_PAY_PLAN_ID ||
            this.isFirstYearFriendInvitationPlan);
    }
    get isFirstYearFriendInvitationPlan() {
        return (this.stripePlanId === FIRST_YEAR_FRIEND_INVITATION_STRIPE_PLAN_ID ||
            this.stripePlanId === FIRST_YEAR_FRIEND_INVITATION_AMAZON_PAY_PLAN_ID);
    }
    isCampaignPricePlanInLB() {
        // megalosなどの協業プランは除外している
        return this.amount === CAMPAIGN_PRICE_TAX_INCLUDE && !this.alliance;
    }
    // フリートライアルがあるかどうか
    hasFreeTrial() {
        return this.freeTrialDays !== 0;
    }
    // 割引率を計算
    discountPercent(targetAmount) {
        return Math.floor(-((this.amount / targetAmount) * 100) + 100);
    }
    // 引数で渡された支払いチャネルと現在の支払いチャネルが一致しているかどうか
    isPaymentChannelMatched(paymentChannel) {
        return this.paymentChannel === paymentChannel;
    }
    // 何ヶ月のプランかの月数を数字で返す
    get periodInMonths() {
        if (this.isAnnualPlan()) {
            return 12;
        }
        else if (this.isSixMonthPlan()) {
            return 6;
        }
        else if (this.isThreeMonthPlan()) {
            return 3;
        }
        return 1;
    }
    // 特定の期間の金額を計算
    amountPerPeriod(period) {
        return this.amountPerMonth * period;
    }
    get amountPerDay() {
        return Math.floor(this.amountPerMonth / 30);
    }
    // 月々の相当金額を計算
    get amountPerMonth() {
        if (this.isAnnualPlan()) {
            return this.amount / 12;
        }
        else if (this.isSixMonthPlan()) {
            return this.amount / 6;
        }
        else if (this.isThreeMonthPlan()) {
            return this.amount / 3;
        }
        return this.amount;
    }
    // 年間の金額を計算
    get amountPerAnnual() {
        if (this.isAnnualPlan()) {
            return this.amount;
        }
        else if (this.isSixMonthPlan()) {
            return this.amount * 2;
        }
        else if (this.isThreeMonthPlan()) {
            return this.amount * 4;
        }
        return this.amount * 12;
    }
    get amountPerMonthWithoutTax() {
        return Math.ceil(this.amountPerMonth / PLAN_TAX);
    }
    get amountWithoutTax() {
        return Math.ceil(this.amount / PLAN_TAX);
    }
    get freeTrialString() {
        if (!this.hasFreeTrial())
            return null;
        if (this.freeTrialDays % 7 === 0)
            return `${this.freeTrialDays / 7}週間`;
        return `${this.freeTrialDays}日間`;
    }
    // キャンペーンプランの場合に次の変更予定プランがシステム側で自動決定している場合(= nextPlanIDが設定されている場合)はプラン変更取り消しボタンを表示しない
    canCancelPlanChanging() {
        return !this.nextPlanId;
    }
    // 法人プランかどうか
    isCorporationPlan() {
        return !!this.corporationId;
    }
}
export class AmazonPayPlan {
    constructor(data) {
        Object.defineProperty(this, "id", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "amount", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "planType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "freeTrialDays", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "nextPlanId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "signature", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "payload", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.id = data.id;
        this.name = data.name;
        this.amount = data.amount;
        this.planType = data.planType;
        this.freeTrialDays = data.freeTrialDays;
        this.nextPlanId = data.nextPlanId;
        this.signature = data.signature;
        this.payload = data.payload;
    }
}
export class BasePlan {
    constructor(data, config) {
        var _a;
        Object.defineProperty(this, "plan", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "amazonPayPlan", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.plan = new Plan(data.plans[0], config);
        if ((_a = data.amazonPayPlans) === null || _a === void 0 ? void 0 : _a.length) {
            this.amazonPayPlan = new AmazonPayPlan(data.amazonPayPlans[0]);
        }
    }
}
